import React from "react";
import PropTypes from "prop-types";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import { makeStyles } from "@material-ui/core/styles";
import cx from "classnames";

const useStyles = makeStyles(() => ({ style: { maxHeight: "100vh" } }));

const ScrollbarWrapper = ({ className, children }) => {
  const classes = useStyles();

  return <SimpleBar className={cx(className, classes.style)}>{children}</SimpleBar>;
};

ScrollbarWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array.isRequired, PropTypes.object.isRequired]),
};

export default React.memo(ScrollbarWrapper);
